<template>
    <div class="modifyPassword">
        <van-nav-bar
            class="nav_bar"
            title="修改登录密码"
            left-arrow
            placeholder
            @click-left="$router.back()"
        />
        <div class="content">
            <div class="inputWrapper">
                <van-field
                    v-model="modifyPassword.password"
                    class="passwordStyle fl"
                    clearable
                    :type="psdtype1"
                    placeholder="请输入旧密码"
                    :border="false"
                />
                <div class="VisibleCutApart fl"></div>

                <div class="Visible fr" @click="handleshowPsd(1)">
                    <img v-if="psdtype1 === 'password'" class="fl" src="../../../assets/images/account/icon-yincang.png" alt="">
                    <img v-else class="fl" src="../../../assets/images/account/icon-xianshi.png" alt="">
                </div>
                <div class="clear"></div>
            </div>

            <div class="inputWrapper">
                <van-field
                    v-model="modifyPassword.passwordNew"
                    class="passwordStyle fl"
                    clearable
                    :type="psdtype2"
                    @focus="inputBlur"
                    placeholder="设置8至20位新登录密码"
                    :border="false"
                />
                <div class="VisibleCutApart fl"></div>

                <div class="Visible fr" @click="handleshowPsd(2)">
                    <img v-if="psdtype2 === 'password'" class="fl" src="../../../assets/images/account/icon-yincang.png" alt="">
                    <img v-else class="fl" src="../../../assets/images/account/icon-xianshi.png" alt="">
                </div>
                <div class="clear"></div>
            </div>

            <div class="inputWrapper">
                <van-field
                    v-model="modifyPassword.repsw"
                    class="passwordStyle fl"
                    clearable
                    :type="psdtype3"
                    @focus="inputBlur"
                    placeholder="再次输入新密码"
                    :border="false"
                />
                <div class="VisibleCutApart fl"></div>

                <div class="Visible fr" @click="handleshowPsd(3)">
                    <img v-if="psdtype3 === 'password'" class="fl" src="../../../assets/images/account/icon-yincang.png" alt="">
                    <img v-else class="fl" src="../../../assets/images/account/icon-xianshi.png" alt="">
                </div>
                <div class="clear"></div>
            </div>

            <div class="OperatingSpace">
                <van-button
                    round type="info"
                    :class="isCompleted ? 'van-button--info' : 'noneVanButton'"
                    @click="confirmModify"
                >确定</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import { passReg } from '../../../utils/validate'
export default {
    name:'modifyPassword',
    data(){
        return{
            psdtype1:'password',
            psdtype2:'password',
            psdtype3:'password',
            modifyPassword:{
                password:'',
                passwordNew:'',
                repsw:''
            },
        }
    },
    computed:{
        isCompleted(){
            for(let key in this.modifyPassword){
                if(!this.modifyPassword[key]) return false
            }
            return true
        }
    },
    methods:{
        inputBlur(){
            let result = true
            if(!this.modifyPassword.passwordNew || !this.modifyPassword.repsw){
                result = false
            }
            if((this.modifyPassword.passwordNew && this.modifyPassword.repsw) && (this.modifyPassword.passwordNew !== this.modifyPassword.repsw)){
                this.$notify({ type: 'warning', message: '两次密码输入不一致，请重新输入' })
                result = false
            }
            return result
        },
        handleshowPsd(num){
            let type = this['psdtype'+num]
            if(type === 'password'){
                this['psdtype'+num] = 'text'
            }else{
                this['psdtype'+num] = 'password'
            }
        },
        confirmModify(){
            if(!this.modifyPassword.password || !this.modifyPassword.passwordNew || !this.modifyPassword.repsw) return
            if(!this.inputBlur()) return
            if(!passReg.test(this.modifyPassword.passwordNew)){
                this.$notify({ type: 'danger', message: '请设置8-20位，数字、大小写字母、字符组合密码'})
                return
            }
            let params = {...this.modifyPassword}
            this.$api.usercenter.changePassword(params).then(res=>{
                if(res.data){
                    this.modifyPswoDialog = false
                    this.$toast({
                        message:'密码修改成功,请重新登录',
                        onClose:() => {
                            localStorage.clear()
                            sessionStorage.clear()
                            this.$router.replace('/login')
                        }
                    })
                    //重置表单
                    this.modifyPassword = {
                        password:'',
                        passwordNew:'',
                        repsw:''
                    }
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
    .content{
        width 622px
        margin 0 auto
    }
    .inputWrapper {
        display flex
        align-items center
        height 128px
        border-bottom 1px solid #D7D7D7
        box-sizing border-box
        .passwordStyle{
            width 548px
            display inline-block
            padding 0
            height 58px
            line-height 58px
            font-size 36px
            font-family PingFangSC-Medium, PingFang SC
            font-weight 500
            color #CCCCCC
            background transparent
        }
        .VisibleCutApart{
            margin 0 24px
            width  2px
            height 32px
            border-radius 1px
            background-color #D7D7D7
        }
        .Visible{
            display inline-block
            img{
                width 48px
            }
        }
    }

    .OperatingSpace{
        width 622px
        position relative
        margin-left -311px
        left 50%
        span{
            color #333333
            font-size 30px
        }
        .van-button{
            width 100%
            height 44px
            line-height 44px
            margin-top 32px
            margin-bottom 24px
            span{
                color #FFFFFF
                font-size 16px
            }
        }
        .noneVanButton{
            background-color #C0D5FF
            border 1px solid #C0D5FF
        }
        .van-button--info{
            background-color linear-gradient(136deg, #227FFF 0%, #316FFF 100%)
            border 1px solid linear-gradient(136deg, #227FFF 0%, #316FFF 100%)
        }
    }

    /* Firefox 4-18 */
    :-moz-placeholder {
        font-size 36px
        font-family PingFangSC-Medium, PingFang SC
        font-weight 500
        color #CCCCCC
        line-height 36px
    }

    /* Firefox 19-50 */
    ::-moz-placeholder {
        font-size 36px
        font-family PingFangSC-Medium, PingFang SC
        font-weight 500
        color #CCCCCC
        line-height 36px
    }

    /* - Internet Explorer 10–11
    - Internet Explorer Mobile 10-11 */
    :-ms-input-placeholder {
        font-size 36px
        font-family PingFangSC-Medium, PingFang SC
        font-weight 500
        color #CCCCCC
        line-height 36px
    }

    /* Edge (also supports ::-webkit-input-placeholder) */
    ::-ms-input-placeholder {
        font-size 36px
        font-family PingFangSC-Medium, PingFang SC
        font-weight 500
        color #CCCCCC
        line-height 36px
    }

    /* CSS Working Draft */
    ::placeholder {
        font-size 36px
        font-family PingFangSC-Medium, PingFang SC
        font-weight 500
        color #CCCCCC
        line-height 36px
    }

</style>